module.exports = {
	"_args": [
		[
			"eslint@^1.9.0",
			"C:\\src\\astexplorer"
		]
	],
	"_from": "eslint@>=1.9.0 <2.0.0",
	"_id": "eslint@1.10.3",
	"_inCache": true,
	"_installable": true,
	"_location": "/eslint",
	"_npmUser": {
		"email": "nicholas@nczconsulting.com",
		"name": "nzakas"
	},
	"_npmVersion": "1.4.28",
	"_phantomChildren": {
		"argparse": "1.0.5",
		"brace-expansion": "1.1.2",
		"deep-is": "0.1.3",
		"esprima": "2.7.2",
		"os-homedir": "1.0.1",
		"prelude-ls": "1.1.2",
		"type-check": "0.3.2",
		"wordwrap": "0.0.2"
	},
	"_requested": {
		"name": "eslint",
		"raw": "eslint@^1.9.0",
		"rawSpec": "^1.9.0",
		"scope": null,
		"spec": ">=1.9.0 <2.0.0",
		"type": "range"
	},
	"_requiredBy": [
		"#DEV:/"
	],
	"_resolved": "https://registry.npmjs.org/eslint/-/eslint-1.10.3.tgz",
	"_shasum": "fb19a91b13c158082bbca294b17d979bc8353a0a",
	"_shrinkwrap": null,
	"_spec": "eslint@^1.9.0",
	"_where": "C:\\src\\astexplorer",
	"author": {
		"email": "nicholas+npm@nczconsulting.com",
		"name": "Nicholas C. Zakas"
	},
	"bin": {
		"eslint": "./bin/eslint.js"
	},
	"bugs": {
		"url": "https://github.com/eslint/eslint/issues/"
	},
	"dependencies": {
		"chalk": "^1.0.0",
		"concat-stream": "^1.4.6",
		"debug": "^2.1.1",
		"doctrine": "^0.7.1",
		"escape-string-regexp": "^1.0.2",
		"escope": "^3.3.0",
		"espree": "^2.2.4",
		"estraverse": "^4.1.1",
		"estraverse-fb": "^1.3.1",
		"esutils": "^2.0.2",
		"file-entry-cache": "^1.1.1",
		"glob": "^5.0.14",
		"globals": "^8.11.0",
		"handlebars": "^4.0.0",
		"inquirer": "^0.11.0",
		"is-my-json-valid": "^2.10.0",
		"is-resolvable": "^1.0.0",
		"js-yaml": "3.4.5",
		"json-stable-stringify": "^1.0.0",
		"lodash.clonedeep": "^3.0.1",
		"lodash.merge": "^3.3.2",
		"lodash.omit": "^3.1.0",
		"minimatch": "^3.0.0",
		"mkdirp": "^0.5.0",
		"object-assign": "^4.0.1",
		"optionator": "^0.6.0",
		"path-is-absolute": "^1.0.0",
		"path-is-inside": "^1.0.1",
		"shelljs": "^0.5.3",
		"strip-json-comments": "~1.0.1",
		"text-table": "~0.2.0",
		"user-home": "^2.0.0",
		"xml-escape": "~1.0.0"
	},
	"description": "An AST-based pattern checker for JavaScript.",
	"devDependencies": {
		"beefy": "^1.0.0",
		"brfs": "0.0.9",
		"browserify": "^12.0.1",
		"chai": "^3.4.0",
		"cheerio": "^0.19.0",
		"coveralls": "2.11.4",
		"dateformat": "^1.0.8",
		"ejs": "^2.3.3",
		"esprima": "^2.4.1",
		"esprima-fb": "^15001.1001.0-dev-harmony-fb",
		"gh-got": "^2.2.0",
		"istanbul": "^0.4.0",
		"jsdoc": "^3.3.0-beta1",
		"jsonlint": "^1.6.2",
		"leche": "^2.1.1",
		"linefix": "^0.1.1",
		"load-perf": "^0.2.0",
		"markdownlint": "^0.0.8",
		"mocha": "^2.1.0",
		"mocha-phantomjs": "4.0.1",
		"npm-license": "^0.3.1",
		"phantomjs": "1.9.18",
		"proxyquire": "^1.0.0",
		"rewire": "^2.3.4",
		"semver": "^5.0.3",
		"shelljs-nodecli": "~0.1.0",
		"sinon": "1.17.2",
		"through": "^2.3.6"
	},
	"directories": {},
	"dist": {
		"shasum": "fb19a91b13c158082bbca294b17d979bc8353a0a",
		"tarball": "http://registry.npmjs.org/eslint/-/eslint-1.10.3.tgz"
	},
	"engines": {
		"node": ">=0.10"
	},
	"files": [
		"LICENSE",
		"README.md",
		"bin",
		"conf",
		"lib"
	],
	"gitHead": "2436cc6c1816a7890e35dab38e609daee84d7530",
	"homepage": "http://eslint.org",
	"keywords": [
		"ast",
		"ecmascript",
		"espree",
		"javascript",
		"lint"
	],
	"license": "MIT",
	"main": "./lib/api.js",
	"maintainers": [
		{
			"name": "nzakas",
			"email": "nicholas@nczconsulting.com"
		},
		{
			"name": "ivolodin",
			"email": "ivolodin@gmail.com"
		}
	],
	"name": "eslint",
	"optionalDependencies": {},
	"readme": "ERROR: No README data found!",
	"repository": {
		"type": "git",
		"url": "git+https://github.com/eslint/eslint.git"
	},
	"scripts": {
		"browserify": "node Makefile.js browserify",
		"check-commit": "node Makefile.js checkGitCommit",
		"coveralls": "cat ./coverage/lcov.info | coveralls",
		"docs": "node Makefile.js docs",
		"gensite": "node Makefile.js gensite",
		"lint": "node Makefile.js lint",
		"major": "node Makefile.js major",
		"minor": "node Makefile.js minor",
		"patch": "node Makefile.js patch",
		"perf": "node Makefile.js perf",
		"profile": "beefy tests/bench/bench.js --open -- -t brfs -t ./tests/bench/xform-rules.js -r espree",
		"test": "node Makefile.js test"
	},
	"version": "1.10.3"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/eslint/package.json
 ** module id = ./node_modules/eslint/package.json
 ** module chunks = 0
 **/